import React, { useState } from 'react';
import { withRouter } from 'react-router';
import { IonHeader, IonToolbar, IonButtons, IonButton, IonIcon, IonItem, IonInput } from '@ionic/react';
import { chevronDown, closeOutline, personOutline, searchOutline } from 'ionicons/icons';
import { connect } from 'react-redux';
import BackButton from '../backButton';
import { checkBackgroundColor, forwardTo, getDefaultRoute, getRouteClassName, isWebConfig } from '../../lib/utils';
import { withTranslation } from '../../lib/translate';
import { getConfig } from '../../appConfig';
import './index.css';

import { NormalText, StrongText, Subtitle, Title } from '../common';
import Basket from '../../lib/basket';

const StaticHeader = ({ dispatch, __, auth, history, backHandler, navConfig, headerIconColors, clientStyles, headerWithTitle, onSearchInputHandler, title, onRestaurantClick, restaurantName }) => {
	const [searchVisible, setSearchVisible] = useState(false)

	const currentPath = history.location.pathname;
	const authPages = getConfig().general.authRoutes.indexOf(currentPath) !== -1;
	const hideStaticHeader = getConfig().theme.routesWithoutStaticHeader.indexOf(currentPath) !== -1;
	const routeClassName = getRouteClassName(currentPath, navConfig);
	let defaultIconsColor = '';
	if (clientStyles?.theme !== 'custom') {
		defaultIconsColor = clientStyles?.theme == 'dark' ? 'white' : 'dark';
	} else {
		defaultIconsColor = clientStyles?.colors?.['--okx-background-color'] ? checkBackgroundColor(clientStyles?.colors['--okx-background-color']) : 'dark';
	}
	return (
		<>
			{hideStaticHeader ? null : getConfig().theme.showHeaderOnAuthRoutes || !authPages ? (
				<IonHeader className={`static ${routeClassName} ${getConfig().general.dashboardWithTiles ? 'colored-header' : 'white-header'}`}>
					<IonToolbar className={`${headerWithTitle ? 'no-logo' : ''} primary-toolbar`}>
						<IonButtons slot="start">
							<BackButton backHandler={backHandler} iconColor={headerIconColors ? headerIconColors : defaultIconsColor} />
						</IonButtons>
						{restaurantName &&
							<StrongText onClick={onRestaurantClick} style={{ display: 'flex', alignItems: 'center', gap: '5px', marginLeft: '20px' }}>
								{restaurantName}
								{onRestaurantClick &&
									<IonIcon icon={chevronDown} style={{ width: '30px', height: '30px' }} />

								}

							</StrongText>

						}

						{title &&
							<IonButtons className='header-title'>
								<IonButton>
									<Title className={title}>
										{title}
									</Title>
								</IonButton>
							</IonButtons>
						}

						<IonButtons slot='end'>
							{!searchVisible ?
								<IonButton onClick={() => setSearchVisible(true)}>
									<IonIcon style={{ color: 'var(--okx-box-wrapper-color)', height: '35px', width: '35px' }} icon={searchOutline} />

								</IonButton>
								:
								<div style={{ display: 'grid', gridAutoFlow: 'column', gap: '15px', alignItems: 'center' }}>
									<IonItem className='header-product-search'>

										<IonInput debounce={300} id='products_search' onIonInput={(e) => onSearchInputHandler(e.target.value)} placeholder='Search products' />
									</IonItem>
									<IonButton onClick={() => { onSearchInputHandler(''); setSearchVisible(false) }}>
										<IonIcon style={{ color: 'var(--okx-box-wrapper-color)', height: '35px', width: '35px' }} icon={closeOutline} />

									</IonButton>
								</div>

							}

						</IonButtons>


					</IonToolbar>
				</IonHeader>
			) : null}
		</>
	);
};

const stateToProps = (store) => {
	const { orders } = store;
	const { clientProfile, navConfig, clientStyles } = store.common;
	const { auth } = store.profile;

	return {
		basketUpdated: orders.basketUpdated,
		clientProfile,
		navConfig,
		clientStyles,
		auth,
	};
};

export default connect(stateToProps)(withRouter(withTranslation(StaticHeader)));
